// AUTH
export const SCANTRUST_AUTH_SUCCESS = 'SCANTRUST_AUTH_SUCCESS'
export const SCANTRUST_AUTH_ERROR = 'SCANTRUST_AUTH_ERROR'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'
export const CHANGE_COMPANY_VISION = 'CHANGE_COMPANY_VISION'
export const ADD_PENDING_REQUEST = 'ADD_PENDING_REQUEST'
export const RESET_PENDING_REQUEST = 'RESET_PENDING_REQUEST'
export const SET_IS_REFRESHING_TOKEN = 'SET_IS_REFRESHING_TOKEN'
export const PROCESS_PENDING_REQUEST = 'PROCESS_PENDING_REQUEST'
export const FORCE_TOKEN_REFRESH = 'FORCE_TOKEN_REFRESH'

// CAMPAIGN
export const INITIALIZING = 'INITIALIZING'
export const CAMPAIGN_LOADED = 'CAMPAIGN_LOADED'
export const INITIALIZED = 'INITIALIZED'
export const IS_CAMPAIGN_LOADED = 'IS_CAMPAIGN_LOADED'
export const IS_LANDING_PAGE_CONFIG_LOADED = 'IS_LANDING_PAGE_CONFIG_LOADED'
export const SET_STC_CONFIG = 'SET_STC_CONFIG'
export const SET_CAMPAIGN_COUNT = 'SET_CAMPAIGN_COUNT'

// PRODUCTS
export const SET_PRODUCTS_LIST = 'SET_PRODUCTS_LIST'
export const SET_PRODUCT_STC_DATA = 'SET_PRODUCT_STC_DATA'
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT'

// REDIRECT
export const SET_CAMPAIGN_REDIRECTION_STATUS = 'SET_CAMPAIGN_REDIRECTION_STATUS'
export const UPDATE_REDIRECTION_URL = 'UPDATE_REDIRECTION_URL'
export const ENABLE_REDIRECTION_TAB = 'ENABLE_REDIRECTION_TAB'
export const UPDATE_CONSUMER_OPTIONS = 'UPDATE_CONSUMER_OPTIONS'

// EDITOR
export const SET_CONFIG_VERSION = 'SET_CONFIG_VERSION'
export const SET_STC_REDIRECT_URL = 'SET_STC_REDIRECT_URL'
export const SET_SERIAL_NUMBER_DISPLAY = 'SET_SERIAL_NUMBER_DISPLAY'
export const SET_PRODUCT_DISPLAY_MODE = 'SET_PRODUCT_DISPLAY_MODE'
export const SET_BRANDING_DISPLAY_MODE = 'SET_BRANDING_DISPLAY_MODE'
export const UPDATE_TAB_BODY = 'UPDATE_TAB_BODY'
export const ADD_NEW_TAB = 'ADD_NEW_TAB'
export const DELETE_TAB = 'DELETE_TAB'
export const UPDATE_TAB_VISIBILITY = 'UPDATE_TAB_VISIBILITY'
export const UPDATE_TAB_NAME = 'UPDATE_TAB_NAME'
export const UPDATE_TAB_ICON = 'UPDATE_TAB_ICON'
export const UPDATE_TAB_ORDER = 'UPDATE_TAB_ORDER'
export const UPDATE_TAB_BODY_CONTENT = 'UPDATE_TAB_BODY_CONTENT'
export const REMOVE_TAB_BODY_CONTENT = 'REMOVE_TAB_BODY_CONTENT'
export const UPDATE_LOGO = 'UPDATE_LOGO'
export const UPDATE_JOURNEY_STEP_DATA = 'UPDATE_JOURNEY_STEP_DATA'
export const SET_TRACK_AND_TRACE_JOURNEY = 'SET_TRACK_AND_TRACE_JOURNEY'
export const ADD_JOURNEY_STEP = 'ADD_JOURNEY_STEP'
export const DELETE_JOURNEY_STEP = 'DELETE_JOURNEY_STEP'
export const UPDATE_THEME_COLOR = 'UPDATE_THEME_COLOR'
export const UPDATE_THEME_TEXT_COLOR = 'UPDATE_THEME_TEXT_COLOR'
export const UPDATE_THEME_BACKGROUND_COLOR = 'UPDATE_THEME_BACKGROUND_COLOR'
export const UPDATE_THEME_DEFAULT_FONT = 'UPDATE_THEME_DEFAULT_FONT'
export const UPDATE_THEME_LANGUAGE_FONT = 'UPDATE_THEME_LANGUAGE_FONT'
export const UPDATE_FOOTER_LOCALE_FIELD = 'UPDATE_FOOTER_LOCALE_FIELD'
export const UPDATE_FOOTER_GDPR_FIELD = 'UPDATE_FOOTER_GDPR_FIELD'
export const UPDATE_FOOTER_SETTING = 'UPDATE_FOOTER_SETTING'
export const UPDATE_COOKIE_FIELD = 'UPDATE_COOKIE_FIELD'
export const CLEAR_URL_LANGUAGE_COPIES = 'CLEAR_URL_LANGUAGE_COPIES'
export const OVERRIDE_COMPONENT_STYLES = 'OVERRIDE_COMPONENT_STYLES'
export const UPDATE_TAB_FLOW = 'UPDATE_TAB_FLOW'
export const ENTER_EDIT_MODE = 'ENTER_EDIT_MODE'
export const LEAVE_EDIT_MODE = 'LEAVE_EDIT_MODE'

export const UPDATE_AUTH_APP_BACKGROUND_COLOR = 'UPDATE_AUTH_APP_BACKGROUND_COLOR'
export const UPDATE_AUTH_APP_BRANDING_LOGO = 'UPDATE_AUTH_APP_BRANDING_LOGO'
export const UPDATE_AUTH_APP_PRIMARY_COLOR = 'UPDATE_AUTH_APP_PRIMARY_COLOR'
export const UPDATE_AUTH_APP_SECONDARY_COLOR = 'UPDATE_AUTH_APP_SECONDARY_COLOR'
export const UPDATE_AUTH_APP_ADVANCED_SETTINGS = 'UPDATE_AUTH_APP_ADVANCED_SETTINGS'
export const UPDATE_AUTH_APP_DEFAULT_FONT = 'UPDATE_AUTH_APP_DEFAULT_FONT'
export const UPDATE_AUTH_APP_LANGUAGE_FONT = 'UPDATE_AUTH_APP_LANGUAGE_FONT'

export const UPDATE_AUTH_MESSAGES = 'UPDATE_AUTH_MESSAGES'
export const UPDATE_AUTH_MESSAGE_STYLES = 'UPDATE_AUTH_MESSAGE_STYLES'

export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const SET_DEFAULT_LANGUAGE = 'SET_DEFAULT_LANGUAGE'
export const SET_ENABLED_LANGUAGES = 'SET_ENABLED_LANGUAGES'
export const RELOAD_EDITOR = 'RELOAD_EDITOR'

export const SAVING = 'SAVING'
export const SAVED = 'SAVED'

export const PUBLISHING = 'PUBLISHING'
export const PUBLISHED = 'PUBLISHED'
export const SET_PUBLISHED_DATA = 'SET_PUBLISHED_DATA'
export const UPDATE_EDITOR_STRINGS = 'UPDATE_EDITOR_STRINGS'
export const APPROVE_LANGUAGE = 'APPROVE_LANGUAGE'
export const UNAPPROVE_LANGUAGE = 'UNAPPROVE_LANGUAGE'
export const UNPUBLISH_LANGUAGE = 'UNPUBLISH_LANGUAGE'
export const SET_COMPANY_LANGUAGES = 'SET_COMPANY_LANGUAGES'

// REMOTE CONFIG
export const SET_REMOTE_STC_CONFIG = 'SET_REMOTE_STC_CONFIG'
export const SET_CONFIG_JSON = 'SET_CONFIG_JSON'

// UTILS
export const UPLOAD_START = 'UPLOAD_START'
export const UPLOAD_DONE = 'UPLOAD_DONE'
export const CHANGE_PREVIEW_MODE = 'CHANGE_PREVIEW_MODE'
export const SET_PREVIEW_LANGUAGE = 'SET_PREVIEW_LANGUAGE'
export const SET_PREVIEW_RESULT = 'SET_PREVIEW_RESULT'
export const TOGGLE_MENU = 'TOGGLE_MENU'

// CUSTOM HTML
export const UPDATE_CUSTOM_HTML_CONTENT = 'UPDATE_CUSTOM_HTML_CONTENT'
export const SET_AI_GENERATING = 'SET_AI_GENERATING'
export const SET_ACTIVE_EDITOR_TAB = 'SET_ACTIVE_EDITOR_TAB'
export const SET_HTML_BLOCKS = 'SET_HTML_BLOCKS'
export const UPDATE_HTML_BLOCK = 'UPDATE_HTML_BLOCK'
export const SET_BLOCKS_META = 'SET_BLOCKS_META'
export const SET_HOVERED_BLOCK_ID = 'SET_HOVERED_BLOCK_ID'
export const SET_PREVIEW_CLICK_EVENT = 'SET_PREVIEW_CLICK_EVENT'
export const DELETE_HTML_BLOCK = 'DELETE_HTML_BLOCK'
export const SAVE_HTML_SNAPSHOT = 'SAVE_HTML_SNAPSHOT'
export const SWAP_AI_HTML = 'SWAP_AI_HTML'

// SNACKBAR
export const SHOW_SNACK_BAR = 'SHOW_SNACK_BAR'
export const DISSMISS_SNACK_BAR = 'DISSMISS_SNACK_BAR'
